/**
 * Share component
 **/

import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import ShareLink from "./share-link";
import { FaShareAlt } from "react-icons/fa";

const Share = ({ props, isCountryPost }) => {
  const data = useStaticQuery(graphql`
    {
      wpOption(id: { eq: "cG9zdDo1NTY=" }) {
        shareOptions {
          countryPostShareTextAppend
        }
        footer {
          share {
            links {
              link {
                target
                title
                url
              }
              type
            }
            text
          }
        }
      }
    }
  `);

  return (
    <section
      className="section m-section-half print:hidden anchor-heading"
      id="share"
    >
      <div className="container relative">
        {data?.wpOption?.footer?.share ? (
          <div className="text-center relative flex items-center justify-center">
            <div
              aria-hidden
              className="text-3xl sm:text-7xl transform mr-0 text-gray-200 opacity-90"
              data-sal="slide-right"
            >
              <FaShareAlt />
            </div>
            <div>
              <div
                className="font-bold max-w-sm leading-snug"
                data-sal="flip-up"
                data-sal-delay="100"
              >
                {props.shareOptions?.shareTextOverride ? (
                  props.shareOptions.shareTextOverride
                ) : (
                  <>
                    Share {props.title}
                    {isCountryPost
                      ? data?.wpOption?.shareOptions?.countryPostShareTextAppend
                      : null}
                  </>
                )}
              </div>
              <ul>
                {data.wpOption.footer.share.links?.map((shareLink, index) => {
                  return (
                    <li
                      className="inline-block ml-3 first:ml-0 mt-2"
                      data-sal="zoom-out"
                      data-sal-delay={index * 100 + 200}
                    >
                      <ShareLink
                        shareLink={shareLink}
                        uri={props.uri}
                        className="btn-gray"
                      />
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        ) : null}
      </div>
    </section>
  );
};

Share.defaultProps = {
  isCountryPost: false,
};

export default Share;
